import styled from "styled-components";

export const ContainerWrapper = styled.div`
    display: grid;
    position: relative;
    height: 100%;
    grid-template-rows: minmax(10%, min-content) minmax(10%, min-content) 1fr min-content min-content min-content;
    padding-bottom: 15px;
`;
